import { Directive } from '@angular/core';

@Directive({
  selector: '[tidyDragDropItem]'
})
export class DragDropItemDirective {
}
